if (!customElements.get('img-n-collection-carousel')) {
    customElements.define(
      'img-n-collection-carousel',
      class FeaturedCollection extends HTMLElement {
        constructor() {
          super();          
        }
  
        connectedCallback() {
          this.selectors = {
            sliderWrapper: '.featured-collection__items',
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          };
          this.classes = {
            flex: 'flex',
            swiper: 'swiper',
            swiperWrapper: 'swiper-wrapper',
          };
  
          this.blockId = this.dataset.blockId;
          this.block = this.closest(`[data-id="${this.blockId}"]`);
          this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
  
          this.items = parseInt(this.dataset.items);
          this.sliderInstance = false;
  
          this.init();
        }
  
        init() {
            this.initSlider();
        }
  
        initSlider() {
          if (typeof this.sliderInstance === 'object') return;
  
          this.sliderOptions = {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: {
              nextEl: this.block.querySelector(this.selectors.nextEl),
              prevEl: this.block.querySelector(this.selectors.prevEl),
            },
            loop: true,
            threshold: 2,
            watchSlidesProgress: true,
            speed: 300,
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 0,
                loop: false,
              }
            },
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
          };
  
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.flex);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
  
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();
  
          // const focusableElements = FoxTheme.a11y.getFocusableElements(this);
  
          // focusableElements.forEach((element) => {
          //   element.addEventListener('focusin', () => {
          //     const slide = element.closest('.swiper-slide');
          //     this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          //   });
          // });
  
          this.calcNavButtonsPosition();
          this.fixQuickviewDuplicate();
        }
  
        destroySlider() {
          this.classList.remove(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper.classList.add(this.classes.flex);
          if (typeof this.sliderInstance !== 'object') return;
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
  
        fixQuickviewDuplicate() {
          let modalIds = [];
          Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
            const modalID = modal.getAttribute('id');
            if (modalIds.includes(modalID)) {
              modal.remove();
            } else {
              modalIds.push(modalID);
            }
          });
        }
  
        calcNavButtonsPosition() {
          const firstMedia = this.querySelector('.product-card__image-wrapper');
          const controls = this.block.querySelector('.swiper-controls');
          if (controls && firstMedia && firstMedia.clientHeight > 0) {
            controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
          }
        }
      }
    );
  }
  